import script from "./TwTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwTextarea.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__